<template lang="pug">
  app-modal(
    titulo="Retificar Cadastro",
    :width="600"
    @closeModal="closeModal"
  )
    template(slot="body")
      p.color-green Passo a passo para o download do .sicarf
      div.margin-left
        p <span class="color-green">1.</span>&nbsp Realizar o download do .sicarf;
        p <span class="color-green">2.</span>&nbsp Importar o .sicarf no Módulo Offline na opção 'Importar cadastro';
        p <span class="color-green">3.</span>&nbsp Realizar as retificações necessárias no cadastro;
        p <span class="color-green">4.</span>&nbsp Após a retificação, realizar o download do .sicarf retificado;
        p <span class="color-green">5.</span>&nbsp Importar o .sicarf novamente no Módulo Receptor;
        p <span class="color-green">6.</span>&nbsp O cadastro voltará para a caixa de entrada do setor.
    template(slot="footer")
      div.flex
        el-button(
          @click="closeModal",
          size="small"
        )
          b Cancelar

        el-button(
          type="success",
          @click="download",
          size="small"
        )
          i.fal.fa-download
          | &nbsp Download
</template>

<script>
import axios from '@/utils/api'
import AppModal from '@/components/AppModal'

export default {

  components: {
    AppModal
  },

  props: {
    idProcesso: {
      type: Number,
      required: true
    }
  },

  methods: {
    closeModal () {
      this.$emit('closeModal')
    },

    async download (file) {
      await axios({
        method: 'GET',
        url: `processo/retificacao/download/${this.idProcesso}`,
        responseType: 'blob'
      })
    }
  }
}

</script>

<style scoped lang="scss">
.color-green {
  color: #009d64;
}
.margin-left {
  margin-left: 15px;
}

.flex {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalRetificacaoCadastro.vue